import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './style/ProcessExamPdf.css';

export default function Digitise() {
  const [questions, setQuestions] = useState([
    "In ABC, right angled at B, if AB = 12 cm and BC = 5 cm, find (i) sin A and tan A (ii) sin C and cot C.",
    "Given 20/cotθ = 21, find all other trigonometric ratios.",
    "If 12/cos A = 13, verify that: 35 sin A(1 - tan A) = 156.",
    "(i) If 7 cot θ = 24, prove that (1 - cos θ)/(1 + cos θ) = 1/7\n(ii) If 4 cot θ = 5, show that: (5 sin θ + 3 cos θ)/(5 sin θ - 2 cos θ) = 2.",
    "If 21 cosec θ = 29, find the value of: (i) (cos^2 θ - sin^2 θ)/(1 - 2 sin^2 θ) (ii) (2 cos^2 θ - 1)/(cos^2 θ - sin^2 θ)",
    "If tan θ + 1/tan θ = 2, show that: tan^2 θ + 1/tan^2 θ = 2.",
    "Evaluate each of the following:\n(i) 2 cos^2 60° cot 30° + 6 sin^2 30° cosec^2 60°\n(ii) (5 sin^2 30° cos 45° - 4 tan 30°)/(2 sin 30° cos 30° tan 45°)\n(iii) 2 (cos^2 45° + tan^2 60°) – 6 (sin^2 45° – tan^2 30°)\n(iv) (tan^2 60° + 3 sec^2 30° + 4 cos^2 45° + 5 cos^2 90°)/(cosec^2 30° + sec^2 60° - cot^2 30°)",
    "If θ = 30°, verify that:\n(i) sin^2 θ + tan^2 θ = 1/(1 + tan^2 θ)\n(ii) (1 - tan^2 θ)/(1 + tan^2 θ) = cos 2θ\n(iii) tan 2θ = 2 tan θ/(1 - tan^2 θ)",
    "Given that sin (A + B) = sin A cos B + cos A sin B, find the value of sin 75°.",
    "If 3 sin (A + 2B) = 2 and cos (A + 4B) = 0, find the values of angles A and B.",
    "ABCD is a rectangle with AD = 12 cm and DC = 20 cm. The line segment DE is drawn making an angle of 30° with AD, intersecting AB in E. Find the lengths of DE and AE.",
  ]);
  const navigate = useNavigate();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingIndex, setEditingIndex] = useState(-1);
  const [editedQuestion, setEditedQuestion] = useState('');
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [questionType, setQuestionType] = useState('');
  const [newQuestion, setNewQuestion] = useState('');
  const [mcqOptions, setMcqOptions] = useState(['', '', '', '']);
  const [animateIn, setAnimateIn] = useState(false);

  useEffect(() => {
    setAnimateIn(true);
  }, []);

  const handleDelete = (index) => {
    setQuestions(questions.filter((_, i) => i !== index));
  };

  const handleNav = () => {
    navigate('/exams/exam-summary');
  };

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditedQuestion(questions[index]);
    setIsEditModalOpen(true);
  };

  const handleSaveEdit = () => {
    if (editingIndex !== -1) {
      const newQuestions = [...questions];
      newQuestions[editingIndex] = editedQuestion;
      setQuestions(newQuestions);
    }
    setIsEditModalOpen(false);
  };

  const handleAddQuestion = () => {
    setIsAddModalOpen(true);
  };

  const handleSaveNewQuestion = () => {
    let finalQuestion = newQuestion;
    if (questionType === 'mcq') {
      finalQuestion += '\nOptions:\n' + mcqOptions.map((opt, index) => `${index + 1}. ${opt}`).join('\n');
    }
    setQuestions([finalQuestion, ...questions]);
    setIsAddModalOpen(false);
    setNewQuestion('');
    setQuestionType('');
    setMcqOptions(['', '', '', '']);
  };

  const handleMcqOptionChange = (index, value) => {
    const newOptions = [...mcqOptions];
    newOptions[index] = value;
    setMcqOptions(newOptions);
  };

  return (
    <div className='bg-gradient-to-br from-blue-100 to-purple-100 '>
    <div className={`unique25-digitise-container  ${animateIn ? 'animate-in' : ''}`}>
      <div className="unique25-background-decoration"></div>
      <h1 className="unique25-digitise-title">Digitized Trigonometry Exam</h1>
      
      <button onClick={handleAddQuestion} className="unique25-add-question-button">
        <span className="unique25-button-text">Add Question</span>
        <span className="unique25-button-icon">+</span>
      </button>

      <div className="unique25-questions-list">
        {questions.map((question, index) => (
          <div key={index} className="unique25-question-card">
            <div className="unique25-question-content">
              <h2 className="unique25-question-number">Question {index + 1}</h2>
              <p className="unique25-question-text">{question}</p>
            </div>
            <div className="unique25-question-actions">
              <button className="unique25-edit-button" onClick={() => handleEdit(index)}>Edit</button>
              <button className="unique25-delete-button" onClick={() => handleDelete(index)}>Delete</button>
            </div>
          </div>
        ))}
      </div>

      {isEditModalOpen && (
        <div className="unique25-modal-overlay">
          <div className="unique25-modal-content">
            <h2 className="unique25-modal-title">Edit Question</h2>
            <textarea
              value={editedQuestion}
              onChange={(e) => setEditedQuestion(e.target.value)}
              className="unique25-modal-textarea"
            />
            <div className="unique25-modal-actions">
              <button className="unique25-modal-save-button" onClick={handleSaveEdit}>Save changes</button>
              <button className="unique25-modal-cancel-button" onClick={() => setIsEditModalOpen(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      {isAddModalOpen && (
        <div className="unique25-modal-overlay">
          <div className="unique25-modal-content">
            <h2 className="unique25-modal-title">Add New Question</h2>
            <select
              value={questionType}
              onChange={(e) => setQuestionType(e.target.value)}
              className="unique25-modal-select"
            >
              <option value="">Select question type</option>
              <option value="qa">Question/Answer</option>
              <option value="mcq">Multiple Choice</option>
              <option value="tf">True/False</option>
              <option value="fib">Fill in the Blank</option>
            </select>
            <textarea
              value={newQuestion}
              onChange={(e) => setNewQuestion(e.target.value)}
              placeholder="Enter your question here"
              className="unique25-modal-textarea"
            />
            {questionType === 'mcq' && (
              <div className="unique25-mcq-options">
                {mcqOptions.map((option, index) => (
                  <input
                    key={index}
                    type="text"
                    value={option}
                    onChange={(e) => handleMcqOptionChange(index, e.target.value)}
                    placeholder={`Option ${index + 1}`}
                    className="unique25-mcq-option-input"
                  />
                ))}
              </div>
            )}
            <div className="unique25-modal-actions">
              <button className="unique25-modal-save-button" onClick={handleSaveNewQuestion}>Add Question</button>
              <button className="unique25-modal-cancel-button" onClick={() => setIsAddModalOpen(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

      <button className="unique25-nav-button" onClick={handleNav}>
        View Exam Summary
      </button>
    </div>
    </div>
  );
}